import React, { useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { TextField, Button } from '@mui/material';
import { ControlledMuiAutoCompleteSelect, IOptionType, PillButton } from '@zz2/zz2-ui';
import { useForm } from 'react-hook-form';
import FreshServiceTicketModelHelper from '../../@types/model/freshService/freshServiceTicketModelHelper';
import { IFreshServiceTicketFormValues } from '../../@types/model/freshService/freshServiceTicketFormValues';
import CustomReactHookFormDevTools from '../customComponents/devTools/ReactHookFormDevTools';

interface IFreshServiceTicketFormProps {
    initialValues : IFreshServiceTicketFormValues;
    onSubmit : (values : IFreshServiceTicketFormValues) => void;
    onCancel : () => void;

    userOptions : Array<IOptionType>;
}

const FreshServiceTicketForm = (props : IFreshServiceTicketFormProps) : React.ReactElement => {
    const schema = FreshServiceTicketModelHelper.formSchema();

    const { register, handleSubmit, trigger, control, formState: { errors, isValid } } = useForm<IFreshServiceTicketFormValues>({
        defaultValues: props.initialValues,
        resolver: yupResolver(schema),
        mode: 'onChange'
    });

    useEffect(() => {
        trigger();
    }, []);

    return (
        <div>
            <form onSubmit={handleSubmit(props.onSubmit)}>
                <div className={'fdc p30 pt15 pb0'}>
                    <div className={'fdc wfill pt10 jcc aic'}>
                        <TextField
                            {...register('systemName')}
                            label={'System Name'}
                            className={'wfill'}
                            error={!!errors.systemName}
                            helperText={errors.systemName ? errors.systemName.message : ''}
                            disabled={true}
                        />
                        <div className='h10' />
                        <TextField
                            {...register('systemVersion')}
                            label={'System Version'}
                            className={'wfill'}
                            error={!!errors.systemVersion}
                            helperText={errors.systemVersion ? errors.systemVersion.message : ''}
                            disabled={true}
                        />
                        <div className='h10' />
                        <TextField
                            {...register('location')}
                            label={'Location'}
                            className={'wfill'}
                            error={!!errors.location}
                            helperText={errors.location ? errors.location.message : ''}
                            disabled={true}
                        />
                        <div className='h10' />
                        <TextField
                            {...register('name')}
                            label={'Name'}
                            className={'wfill'}
                            error={!!errors.name}
                            helperText={errors.name ? errors.name.message : ''}
                            disabled={true}
                        />
                        <div className='h10' />
                        <TextField
                            {...register('email')}
                            label={'Email'}
                            className={'wfill'}
                            error={!!errors.email}
                            helperText={errors.email ? errors.email.message : ''}
                            disabled={true}
                        />
                        <div className='h10' />
                        <TextField
                            {...register('description')}
                            label={'Description'}
                            className={'wfill'}
                            multiline={true}
                            rows={4}
                            variant={'standard'}
                            error={!!errors.description}
                            helperText={errors.description ? errors.description.message : ''}
                        />
                        <div className='h10' />
                        <ControlledMuiAutoCompleteSelect 
                            name='referencedUser'
                            control={control}
                            label={'Manager'} 
                            className={'wfill'}
                            defaultValues={props.initialValues.referencedUser ?? null}
                            options={props.userOptions}
                        />
                    </div>
                    <div className='h20' />
                    <div className={'fdr flx1 aic jcfe mb20'}>
                        <Button
                            className={'cpd mr20'}
                            onClick={props.onCancel}
                            type={'reset'}>
                            CANCEL
                        </Button>
                        <PillButton
                            className={'pl30 pr30'}
                            text={'SAVE'}
                            size={'small'}
                            type={'submit'}
                            color={'secondary'}
                            disabled={!isValid}
                        />
                    </div>
                </div>
            </form>
            <CustomReactHookFormDevTools control={control} />
        </div>
    );
};

export default FreshServiceTicketForm;
